(function () {
  'use strict';
  var KEY = 'wishlist';

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function save(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateCount();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: list }));
  }
  function has(handle) { return get().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = get(), i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    save(list);
    return i === -1;
  }
  function removeHandle(handle) {
    var list = get(), i = list.indexOf(handle);
    if (i !== -1) { list.splice(i, 1); save(list); }
  }
  function count() { return get().length; }

  function updateButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = has(btn.getAttribute('data-wishlist-handle'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = active ? btn.getAttribute('data-label-added') : btn.getAttribute('data-label-add');
      if (label) btn.setAttribute('aria-label', label);
    });
  }
  function updateCount() {
    var n = count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function card(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var vid = p.variants[0] && p.variants[0].id;
    return '<div class="wishlist-card" data-handle="' + p.handle + '">' +
      '<a href="/products/' + p.handle + '" class="wishlist-card__image">' +
        (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
      '</a>' +
      '<div class="wishlist-card__info">' +
        '<a href="/products/' + p.handle + '" class="wishlist-card__title">' + esc(p.title) + '</a>' +
        '<div class="wishlist-card__price">' + money(p.price) + '</div>' +
        '<div class="wishlist-card__actions">' +
          '<button type="button" class="wishlist-card__add" data-add-to-cart data-variant-id="' + vid + '"' +
            (p.available ? '' : ' disabled') + '>' + (p.available ? 'Add to cart' : 'Sold out') + '</button>' +
          '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' + p.handle + '" aria-label="Remove">&times;</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function renderPage(container) {
    var list = get();
    var grid = container.querySelector('[data-wishlist-grid]');
    var empty = container.querySelector('[data-wishlist-empty]');
    grid.innerHTML = '';
    if (!list.length) { empty.hidden = false; grid.hidden = true; return; }
    empty.hidden = true; grid.hidden = false;

    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      products.forEach(function (p, i) {
        if (!p) { removeHandle(list[i]); return; }
        grid.insertAdjacentHTML('beforeend', card(p));
      });
      updateButtons();
    });
  }

  // Click handling (delegated)
  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      toggle(toggleBtn.getAttribute('data-wishlist-handle'));
      updateButtons();
      return;
    }
    var rm = e.target.closest('[data-wishlist-remove]');
    if (rm) {
      removeHandle(rm.getAttribute('data-wishlist-remove'));
      var pg = document.querySelector('[data-wishlist-page]');
      if (pg) renderPage(pg);
      return;
    }
    var add = e.target.closest('[data-add-to-cart]');
    if (add) {
      var id = add.getAttribute('data-variant-id');
      if (!id) return;
      add.disabled = true; add.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () {
          add.textContent = 'Added ✓';
          // Concept cart-drawer refresh — see note in chat
          document.dispatchEvent(new CustomEvent('wishlist:added-to-cart', { detail: { id: id } }));
        })
        .catch(function () { add.disabled = false; add.textContent = 'Add to cart'; });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateButtons();
    updateCount();
    var pg = document.querySelector('[data-wishlist-page]');
    if (pg) renderPage(pg);
  });

  // Sync across tabs
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    updateButtons(); updateCount();
    var pg = document.querySelector('[data-wishlist-page]');
    if (pg) renderPage(pg);
  });

  window.Wishlist = { get: get, has: has, toggle: toggle, count: count,
    refresh: function () { updateButtons(); updateCount(); } };
})();